export default __webpack_public_path__ + "static/media/vegan.47dbf576.png";